import styled from "styled-components";
import FormTest from "./bodyTest/FormTest";

const BodyTest = (props) => {

    const { testId, test } = props;

    return (
        <Container>
            <h1>Inscripción al test de conocimientos</h1>
            <h2>Competencia: {test?.name}</h2>
            <Description>
                <p>
                    <b>¡Te damos la bienvenida al Test de habilidades de Acrópolis LAB!</b>
                </p>
                <br />
                <p>
                    Estamos encantados de que hayas decidido participar en este test, diseñado para evaluar tus competencias
                    y ayudarte a conocer mejor tus fortalezas, así como identificar áreas de oportunidad para tu desarrollo personal y profesional.
                </p>
                <br />
                <p><b>Descripción del test:</b></p>
                <br />
                <p>
                    {test?.description}
                </p>
            </Description>
            <FormTest testId={testId} />
            <p><b>¡Te deseamos mucho éxito y esperamos que este test sea un paso positivo en tu crecimiento!</b></p>
        </Container>
    )
}

export default BodyTest;

const Container = styled.div`
    width: 60vw;
    max-width: 700px;
    min-height: 100vh;
    height: 100%;
    background-color: #FFF;
    border-radius: 30px;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    gap: 24px;

    @media (width < 1000px) {
        width: calc(100% - 6rem);
        padding: 2rem;
    }

    h1 {
        font-size: 24px;
        font-weight: 700;
        color: #1D1D18;
    }

    h2 {
        font-size: 20px;
        font-weight: 700;
        color: #b31d15;
        text-align: center;
    }
`

const Description = styled.p`
    width: 100%;
    color: #1D1D18;
    font-size: 16px;

    ol {
        margin-left: 1rem;
    }
`
